<template>
  <div class="main">
    <section class="main-section">
      <p class="btn-item" v-if="isPermission('Chairman')">
        <router-link to="/admin/archive/edit/create">
          <button type="button" class="el-button el-button--primary">
            <i class="el-icon-circle-plus"></i><span>新規書類追加</span>
          </button>
        </router-link>
      </p>

      <h3 class="section-title green-left-head">マンション書庫</h3>

      <p class="section-block">
        マンションに関する書類等を確認・ダウンロードできます。
      </p>
    </section>
    <!--/.main-section-->

    <section
      class="main-section buttons cloumBtns"
      v-if="isPermission('Chairman')"
    >
      <p
        class="section-block center"
        v-for="(item, index) in categories"
        :key="index"
      >
        <router-link
          :to="{ name: 'archive-list', params: { category: item._id } }"
        >
          <button class="bt bt-green">{{ item.title }}</button>
        </router-link>
      </p>
    </section>
    <section class="main-section buttons cloumBtns" v-else>
      <p
        class="section-block center"
        v-for="(item, index) in norm_categories"
        :key="index"
      >
        <router-link
          :to="{ name: 'archive-list', params: { category: item._id } }"
        >
          <button class="bt bt-green">
            {{ item.title }}
          </button>
        </router-link>
      </p>
    </section>
    <!--/.main-section-->

    <IconMenu />
    <!--/.main-section-->
  </div>
  <!--/.main-->
</template>

<script>
// import store from "../../store";
import CategoryService from "../../services/category.service";
import IconMenu from "@/components/IconMenu.vue";
import ArchiveService from "../../services/archive.service";
export default {
  name: "archive-index",
  components: { IconMenu },
  // beforeRouteEnter(to, from, next) {
  //   const currentUser = store.state.auth.user;
  //   console.log(currentUser);
  //   if (currentUser && !currentUser.permissions.includes("Director")) {
  //     console.log(":401");
  //     next({ name: "notfound404" });
  //   } else {
  //     next();
  //   }
  // },
  data: function() {
    return {
      categories: [],
      counter: [],
    };
  },
  computed: {
    norm_categories() {
      return this.categories.filter((elem, index) => {
        return this.counter[index] != 0;
      });
    },
  },
  mounted: async function() {
    try {
      console.log("+++ mountd");
      const count = await ArchiveService.count();
      this.counter = count.data;
      const res = await CategoryService.get();
      console.log(res);
      this.categories = res.data;
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style></style>
